import { FilterId, type PrimaryFilterId } from '../../../filters/types/filters';
import { useTabContentConfig } from '../../PageConfigProvider/PageConfigProvider';
import type { ReportParameterConfig } from '../../PageConfigProvider/page-reducer';

export const useUpdateParameters = () => {
  const { dispatch } = useTabContentConfig();
  return (params: ReportParameterConfig[]) => {
    dispatch({
      type: 'SET_REPORT_PARAMETERS',
      payload: params,
    });
    const primaryParam = params?.find((p) => p.isPrimary);
    const primaryId = primaryParam?.filterId;
    if (
      primaryId === FilterId.COMPANY ||
      primaryId === FilterId.GEOGRAPHY ||
      primaryId === FilterId.ROLE
    ) {
      dispatch({
        type: 'UPDATE_PRIMARY_FILTER',
        payload: primaryId as PrimaryFilterId,
      });
    } else {
      throw new Error(`Can not update primary filter to ${primaryId}.`);
    }
  };
};
